export const PAGE_MODULES = Object.freeze({
  ALGOLIA_CARDS: "algolia-cards",
  HERO: "heroes",
  CATEGORY_COLLECTIONS: "category-collections",
  MODULE_MENU: "module-menu",
  CATEGORY_ROW: "category-rows",
  CATEGORY_HEROES: "category-heroes",
  MODULE_SLIDER: "module-slider",
});

export const NON_RENDER_COUNT_MODULES = Object.freeze({
  HERO: PAGE_MODULES.HERO,
  MODULE_MENU: PAGE_MODULES.MODULE_MENU,
  CATEGORY_HEROES: PAGE_MODULES.CATEGORY_HEROES,
});
